export const ALPHABET_SPACE_PATTERN = /^[A-Za-z ]+$/;

export const CLIENT_NAME_PATTERN = /^[A-Za-z-.'&() ]+$/;

export const NUMBER_ONLY_PATTERN = /^[0-9]+$/;

export const NUMBER_DOT_PATTERN = /^[0-9-.]+$/;

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=<>?])[A-Za-z\d!@#$%^&*()-_+=<>?]{8,32}$/;

export const ALPHABET_PATTERN = /^[A-Za-z]+$/;

export const ALPHABET_NUMBER_PATTERN = /^[A-Za-z0-9]+$/;

export const PAN_NUMBER_PATTERN = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

export const GST_PATTERN =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const NOT_ALLOW_SPACE = /^\S*$/;

export const ALPHABET_NOT_ALLOW_SPACE = /^[a-zA-Z][a-zA-Z\\s]+$/;

export const MOBILE_NO_PATTERN = /^\d{10}$/;

export const URL_PATTERN =
  /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;

export const GOOGLE_MAP_URL_PATTERN =
  /^(https?:\/\/)((www\.)?google\.com\/maps\/(place|search|dir|@).+|(maps\.app\.goo\.gl|bit\.ly|klr\.bz|share\.google)\/.+)/;

export const VEHICLE_PATTERN =
  // /^[A-Z]{2}[\\ -]{0,1}[0-9A-Z]{2}[\\ ""-]{0,1}[0-9A-Z]{1,2}[\\ -]{0,1}[0-9]{1,4}$/;
  /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{4}$/
// export const VEHICLE_PATTERN =
//   /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/;
// /^[A-Z]{2}[\\ -]{0,1}[0-9]{2}[\\ ""-]{0,1}[A-Z]{1,2}[\\ -]{0,1}[0-9]{4}$/;

export const VEHICLE_SPACE = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/;

export const INVOICE_VEHICLE_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;

const STATE =
  '(?:AN|AP|AR|AS|BR|CG|CH|DD|DL|DN|GA|GJ|HP|HR|JH|JK|KA|KL|LA|LD|MH|ML|MN|MP|MZ|NL|OD|OR|PB|PY|RJ|SK|TG|TN|TR|TS|UA|UK|UP|WB)';

export const VEHICLE_NO_REGEX = new RegExp(
  `^(?:` +
  // Standard: state + RTO(1-99) + series(1-3 letters) + number(1-4 digits, not all zero)
  `${STATE}(?:0[1-9]|[1-9]\\d?)(?:[A-Z]{1,3}(?!0+$)\\d{1,4}|(?!0+$)\\d{4})` +
  `|` +
  // Bharat series: YY BH NNNN X(X), no I or O in the letters
  `\\d{2}BH(?!0000)\\d{4}[A-HJ-NP-Z]{1,2}` +
  `)$`
);

export const normalizeVehicleNo = (v: string) =>
  v.toUpperCase().replace(/[\s.\-]/g, '');

export const isValidVehicleNo = (v: string) =>
  VEHICLE_NO_REGEX.test(normalizeVehicleNo(v));

export const DECIMAL_PATTERN = /^\d*\.?\d{0,3}$/;

export const DECIMAL_PATTERN_2_DECIMAL_PLACE = /^\d*\.?\d{0,2}$/;

export const DECIMAL_PATTERN_NEGATIVE_POSITIVE = /^-?\d*\.?\d{0,3}$/;

export const TWO_DECIMAL_PATTERN = /^\d*\.?\d{0,2}$/;

export const INDIAN_MOBILE_NO_PATTERN = /^(0?)[6789]{1}\d{9}$/;

export const IFFC_CODE_PATTERN = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;

export const ALPHABET_NUMBER_SPACE_PATTERN = /^[a-zA-Z 0-9]+$/;

export const ALPHANUMERIC_SPACE_PUNCTUATION_PATTERN = /^[a-zA-Z0-9 .,']+$/;

export const NOT_ALLOWED_SPECIAL_CHARACTERS_PATTERN = /^[^'"`]+$/;

export const NAME_PATTERN = /^[a-zA-Z ._]+$/;

export const ORIENTATION_PATTERN = /^[DF]+$/;

export const ALPHABET_NUMBER_SPACE_HYPHEN_PATTERNS = /^[a-zA-Z-0-9 ]+$/;

export const ALPHABET_NUMBER_SPACE_PATTERN_DOT_ALLOW = /^[a-zA-Z 0-9.]+$/;

export const ADDRESS_PATTERN = /^[a-zA-Z 0-9.:\\-\\/,'&()-]+$/;

export const BENEFICEIARY_NAME = /^[a-zA-Z -,]+$/;

export const ACCOUNT_NUMBER_PATTERN = /^[a-zA-Z0-9]{8,35}$/;

export const ALPHABET_WITH_SPECIAL_CHAR =
  /^[a-zA-Z \-!,@#$%^&*()_+={}[\]|;:'",.<>/?]+$/;

export const ONLY_ZERO_NUMBER = /^(?!0+$).+/;

export const DECIMAL_PATTERN_2_DIGITS = /^\d+(\.\d{0,2})?$/;

export const INVOICE_PATTERN = /^[a-zA-Z / 0-9]+$/

export const FILENAME_PATTERN = /^[^\/:*?"<>|%]+$/;

export const PASTE_PATTERN_FOR_NUMBER = /\D/g;

export const PASTE_PATTERN_FOR_ALPHABET = /\s+/g;

export const DECIMAL_PATTERN_WORK_ORDER = /^\d+(\.\d+)?$/

export const ACCOUNT_NUMBER_PATTERN_SLAS = /^[a-zA-Z0-9\/]+$/;

export const ALPHABETS_NUMBER_PATTERN_SLASH = /^[A-Za-z0-9/]+$/;

export const ALPHABETS_NUMBER_UNDERSCORE = /^[a-zA-Z0-9_ -]+$/

export const GOOGLE_MAP_LINK = /^(https?:\/\/)?(www\.)?(maps\.app\.goo\.gl|goo\.gl\/maps|g\.co\/kgs|google\.com\/maps|maps\.google\.com|klr\.bz)\/[^\s]+$/
export const ORDER_NUMBER_SEARCH_PATTERN = /^[0-9]+(\/[vV]?(-[0-9]*)?)?$/;

// TBS handle Fabrication Code: starts with a letter / number, then letters, numbers, space and - _ / . (max 30; same rule as the API)
export const TBS_FABRICATION_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 \-_/.]{0,29}$/;
